import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridMultiple } from "./gridSettings/gridSettings";

export const AutorizzazioneArea: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'autorizzazioni',
      idBreadcrumbGroup: 'autorizzazione',
      campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
      service: 'autorizzazionearea',
      api: 'AutorizzazioneArea',
      filterList: '?idAutorizzazione=$idAutorizzazione',
      filterEditor: '/$',
      helpDoc: 'AutorizzazioneArea.html',
      queryFilter: [
        {
          key: 'idAutorizzazione',
          value: 'idAutorizzazione'
        },
        {
          key: 'idSede',
          value: 'idSede'
        },

      ],
      idTabRif: [

        {
          key: 'idAutorizzazione',
          value: 'idAutorizzazione'
        },


      ],

      formType: 'simple',
      masterKey: 'id',
      nCol: 1,
      toolbarSettings: {
        service: 'autorizzazione',



      }


    },
  },
  {
    itemType: "buttonMenu", colCount: "2", class: "col-12", caption: "", data: [
      {
        type: 'menuToolbar', orderGriglia: 1, colVisible: true, hideOnEdit: true, disableOnUpdate: true, buttons: [


          { name: 'Utility', icon: 'mdi mdi-settings-outline', displayMode: 'in-line', hint: 'Utility', value: 'utl', location: 'bottom', visible: true },

        ]
      }
    ]
  },
  {
    itemType: "group", colCount: "1", caption: 'Definizione Area - Zona Autorizzata', class: '',

    data: [
      { showInColumnChooser: false, type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },
      { showInColumnChooser: false, type: 'campo', dataField: "idAutorizzazione", colVisible: false, dataType: "", caption: "idAutorizzazione", hideOnEdit: true },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "descrizioneArea", caption: "Area/Zona", dataType: "",
        maxLength: "10",
        validation: [{
          type: 'required', message: 'Area/Zona obbligatoria'
        }],

      },




    ]
  },

  {
    itemType: "group", colCount: "2", caption: '', class: '', data: [
      { type: 'empty', colSpan: '2', class: 'py-0', dataField: "", colVisible: false, dataType: "", caption: "Quantitativi max gestibili (ton)", hideOnEdit: false, },

      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxGiacenza", colVisible: true, dataType: "", caption: "Max giacenza ist", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',

      },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxCaricoAnno", colVisible: true, dataType: "", caption: "Max carico anno", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',

      },


      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campoSpecial', dataField: "listaModStoccaggioDesc", dataType: "", caption: "Modalità di stoccaggio",
        colWidth: 55,
        width: '485px',
        colSpan: '2',
        colVisible: true,
        labelVisible: true,

        disableOnUpdate: true,
        dynamic: {

          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Smaltimento",
          queryString: '',

          componentType: 'dynamicGrid',
          related: ['listaModStoccaggio'],
          enableEditor: {
            add: true,
            remove: true,
            update: true
          },
          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })

        }
      },

      {
        allowHiding: false, showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "listaModStoccaggio",
        editorType: "dxAutocomplete",
        labelVisible: true,
        dataType: "",

        caption: "Mod. Stoccaggio ",
        class: "d-none",
        colSpan: '2',
        disableOnUpdate: true,
        costantValue: [{ key: 'nomeTabella', value: 'autorizzazioni' }],
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          displayExpr: '',
          caption: "Lista Modalità Stoccaggio",
          queryString: '/',
          filter: '/',
          componentType: 'grid',
          related: ['id|listaModStoccaggioDesc'],
          enableEditor: {
            add: true,
            remove: true,
            update: true
          },

        }

      },

      { type: 'empty', colSpan: '2', class: 'py-0', dataField: "", colVisible: false, dataType: "", caption: "Quantitativi max trattabili (ton)", hideOnEdit: false, },

      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxTrattamentoGiorno", colVisible: true, dataType: "", caption: "Max giornaliero", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
      },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxTrattamentoAnno", colVisible: true, dataType: "", caption: "Max anno", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
      },

      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campoSpecial', dataField: "listaModTrattamentoDesc", dataType: "", caption: "Modalità di trattamento",
        colSpan: '2',
        colVisible: true,
        labelVisible: true,
        costantValue: [{ key: 'nomeTabella', value: 'autorizzazioni' }],
        width: '485px',
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Trattamento",
          queryString: '',
          filter: '/',
          componentType: 'dynamicGrid',
          related: ['listaModTrattamento'],
          enableEditor: {
            add: true,
            remove: true,
            update: true
          },
          buttonOption: {
            text: 'Modalità di Trattamentoo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Trattamento',
            name: 'trattamento',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "listaModTrattamento", colCaption: 'Modalità Trattamento',
        editorType: "dxAutocomplete",
        labelVisible: false,
        dataType: "",

        colSpan: '2',
        caption: "Mod. Trattamento ",
        class: "d-none",
        disableOnUpdate: true,
        costantValue: [{ key: 'nomeTabella', value: 'autorizzazioni' }],
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',

          displayExpr: '',
          caption: "Lista Modalità Trattamento",
          queryString: '/',
          filter: '/',

          related: ['id|listaModTrattamentoDesc'],
          enableEditor: {
            add: true,
            remove: true,
            update: true
          },

        }

      },
    ]

  },
  {
    itemType: "group", caption: 'Elenco Codici EER aggregati AREA/ZONA', colCount: "1", class: "col-12  ",
    data: [


      {
        allowHiding: false, showInColumnChooser: false,
        type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'autorizzazioneAreaCer',

        colVisible: false,
        width: 1500,
        /**Tipo Dynamico ma apre componente Griglia non in popup**/

        dynamic: {

          dataSource: '',
          service: 'autorizzazioneareacer',
          autocomplete: false,

          valueExpr: '',
          campoTabRif: '',
          displayExpr: 'descrizione',
          caption: "Lista Autorizzazioni CER Zona",
          componentType: 'dynamicGrid',
          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'cer',
            keyUnique: '',
            mode: 'cell',
            height: 400,
            remoteOperations: false, //Abilitato per il salvataggio edit e delete
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            showFilterSearch: false,
            showColBlank: true
          }

        }






      }
    ]

  },
]


export const AutorizzazioneArea2: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'autorizzazioni',
      idBreadcrumbGroup: 'autorizzazione',
      campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
      service: 'autorizzazionearea',
      api: 'AutorizzazioneArea',
      filterList: '?idAutorizzazione=$idAutorizzazione',
      filterEditor: '/$',
      helpDoc: 'AutorizzazioneArea.html',
      queryFilter: [
        {
          key: 'idAutorizzazione',
          value: 'idAutorizzazione'
        },
        {
          key: 'idSede',
          value: 'idSede'
        },

      ],
      idTabRif: [

        {
          key: 'idAutorizzazione',
          value: 'idAutorizzazione'
        },


      ],

      formType: 'simple',
      masterKey: 'id',
      nCol: 3,
      toolbarSettings: {
        service: 'autorizzazione',



      }


    },
  },

  {
    itemType: "group", colCount: "1", caption: 'Definizione Area - Zona Autorizzata', class: '',

    data: [
      { showInColumnChooser: false, type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },
      { showInColumnChooser: false, type: 'campo', dataField: "idAutorizzazione", colVisible: false, dataType: "", caption: "idAutorizzazione", hideOnEdit: true },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "descrizioneArea", caption: "Area/Zona", dataType: "",
        maxLength: "10",
        uppercase:true,
        nCol: 5,
        colWidth:400,
        validation: [{
          type: 'required', message: 'Campo obbligatorio'
        }],

      },




    ]
  },

  {
    itemType: "group", colCount: "2", caption: 'Quantitativi max gestibili (ton)', data: [

      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxGiacenza", colVisible: true, dataType: "", caption: "Max giacenza ist", hideOnEdit: false,
        editorType: 'dxNumberBox',
        labelWidth:150,
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
        colWidth:120,
      },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxCaricoAnno", colVisible: true, dataType: "", caption: "Max carico anno", hideOnEdit: false,
        editorType: 'dxNumberBox',
        labelWidth:150,
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
        colWidth:120,
      },


      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campoSpecial', dataField: "listaModStoccaggioString",
        dataType: "", caption: "Modalità di stoccaggio",
       
        nCol: 10,
        colSpan: '2',
        labelWidth:150,
        colVisible: true,
        labelVisible: true,
        colWidth:400,
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Smaltimento",
          queryString: '',
          related:['object|listaModStoccaggioGeneric'],
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,

              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })

        }
      },


    ]
  },
  {
    itemType: "group", colCount: "2", caption: 'Quantitativi max trattabili (ton)', data: [


      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxTrattamentoGiorno", colVisible: true, dataType: "", caption: "Max giornaliero", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
        labelWidth:150,
        colWidth:120,
      },
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campo', dataField: "maxTrattamentoAnno", colVisible: true, dataType: "", caption: "Max anno", hideOnEdit: false,
        editorType: 'dxNumberBox',
        nCol: 5,
        maxLength: '9',
        format: '#0.###',
        labelWidth:150,
        colWidth:120,
      },

      {
        allowHiding: false,
        showInColumnChooser: true,
        type: 'campoSpecial', dataField: "listaModTrattamentoString",
        dataType: "",
        caption: "Modalità di trattamento",
        colSpan: '2',
        colVisible: true,
        labelVisible: true,
        labelWidth:150,
        colWidth:400,
        nCol: 10,
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Trattamento",
          queryString: '',
          componentType: 'dynamicGrid',
          related:['object|listaModTrattamentoGeneric'],
          buttonOption: {
            text: 'Modalità di Trattamentoo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Trattamento',
            name: 'trattamento',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
            
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },

    ]

  },
  {
    itemType: "group", colSpan: '3', groupWidth:1150, caption: 'Elenco Codici EER aggregati AREA/ZONA', colCount: "1", class: "col-12  ",
    data: [


      {
        type: 'campoGriglia',
        colVisible: false,
        dataField: "autorizzazioneAreaCer",
        dataType: "",
        nCol: 10,
        colSpan: 4,
        width: 100,
        caption: "",
        class: '',
        allowHiding: false,
        showInColumnChooser: false,
        formGrid: {
          service: 'AutorizzazioneAreaCer2',
          api: '',
          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          showToolbarTop: true,
          tableHeight: 350,
          tableWidth: 1000,
          showFilter: false,
          selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
          idTable: 'autorizzazioneAreaCer',
          isSearchable: false

        }
      },


    ]

  },
]